<div class="vtz-main-wrapper">
  <div class="vtz-main-container vtz-main-container--ballot">
    <div class="vtz-title-section vtz-title-section--blue">
      <app-header></app-header>
    </div>
    <main>
      <h1 class="vtz-h1" id="main-title" i18n>Poll Questions</h1>
      @if (contestList.length > 0){
        <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
          Click on a poll question to view a summary of responses.
        </p>
      } @else {
        <p class="vtz-text vtz-text--wide vtz-text--center" i18n>
          There are no poll questions.
        </p>
      }
      <div role="list">
        @for (contest of contestList; track contest; let i = $index) {
          <button class="button-container" (click)="selectContest(i)" role="listitem">
            <span class="button-text">
              {{ contest.description}} <br>
              @if (contest.description1){
                {{ contest.description1}} <br>
              }
              @if(contest.description2){
                {{contest.description2 }} <br>
              }
            </span>
            <mat-icon class="button-icon">insert_chart_outlined</mat-icon>      
          </button>
        }
      </div>
      <div id="vtz-actions" class="vtz-actions">
        <div id="button-group" class="dialog-button-container">
          <button id="back-to-dashboard" class="button-primary" (click)="backToDashboard()" i18n="Button label">
            DASHBOARD
          </button>
          <button id="back-to-poll-decision" class="button-primary" (click)="goToPoll()" i18n="Button label">
            BACK
          </button>
        </div>
      </div>
    </main>
  </div>
</div>

